module.exports = __webpack_public_path__ + "static/img/bg_parkwinter.36e6d0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/backgrounds/thumbnail/bg_parkwinter.png
// module id = AoS4
// module chunks = 0